import d3 from '../../../../globalexports/d3.export';

export const clearGridViewCanvas = () => {
  d3.select('#gridview-canvas-images').html('');
};
